module.exports = __webpack_public_path__ + "img/dimensie-lichaamsfuncties.092bbf1b.svg";